module.exports = __webpack_public_path__ + "img/kafeizong.fea53a0f.png";